import apiClient from './api';

export interface BackgroundImage {
  _id: string;
  name: string;
  description?: string;
  imageUrl: string;
  originalName: string;
  mimeType: string;
  size: number;
  isLibrary: boolean;
  tags: string[];
  usageCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface BackgroundImageListResponse {
  success: boolean;
  images: {
    own: BackgroundImage[];
    library: BackgroundImage[];
  };
}

export interface BackgroundImageResponse {
  success: boolean;
  image: BackgroundImage;
}

const BASE = '/background-images';

export const backgroundImageApi = {
  // List all background images (own + library)
  getImages: async (): Promise<BackgroundImageListResponse> => {
    const res = await apiClient.get(BASE);
    return res.data;
  },

  getImage: async (id: string): Promise<BackgroundImageResponse> => {
    const res = await apiClient.get(`${BASE}/${id}`);
    return res.data;
  },

  uploadImage: async (formData: FormData): Promise<BackgroundImageResponse> => {
    const res = await apiClient.post(BASE, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },

  updateImage: async (id: string, data: { name?: string; description?: string; tags?: string }): Promise<BackgroundImageResponse> => {
    const res = await apiClient.put(`${BASE}/${id}`, data);
    return res.data;
  },

  deleteImage: async (id: string): Promise<{ success: boolean; message: string }> => {
    const res = await apiClient.delete(`${BASE}/${id}`);
    return res.data;
  },

  // Build image URL via /api/background-images/image/:filename — works through nginx proxy
  getImageSrc: (imageUrl: string): string => {
    if (!imageUrl) return '';
    if (imageUrl.startsWith('http')) return imageUrl;
    const filename = imageUrl.split('/').pop();
    if (!filename) return '';
    const apiBase = (import.meta as any).env?.VITE_API_URL ?? '/api';
    const base = apiBase.replace(/\/?$/, '');
    return `${base}/background-images/image/${filename}`;
  },
};
